import { render, staticRenderFns } from "./VideoPlayHomeTwo.vue?vue&type=template&id=0d491d20&"
import script from "./VideoPlayHomeTwo.vue?vue&type=script&lang=js&"
export * from "./VideoPlayHomeTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports